<template>
  <div>
    <v-row class="mb-3" align="center" justify="center">
      <v-col lg="2" sm="6" cols="12">
          <v-select
            :items="statusFillter"
            :label="$t('Status')"
            :item-text="__attr"
            v-model="configDatatale.paramsRequest.status"
            outlined
            dense
            hide-details
          ></v-select>
      </v-col>
      <v-col lg="3" sm="6" cols="12">
        <v-autocomplete
          auto-select-first
          :label="$t('Employee')"
          :items="selectUsers"
          :placeholder="$t('Select an option')"
          v-model="configDatatale.paramsRequest.user_id"
          clearable
          hide-details
          dense
          outlined
        />
      </v-col>
      <v-col lg="3" sm="5" cols="12">
        <v-row>
            <v-col md="6">
              <datepicker v-model="configDatatale.paramsRequest.from_date" :label="$t('From date')"/>
            </v-col>
            <v-col md="6">
              <datepicker v-model="configDatatale.paramsRequest.to_date" :label="$t('To date')"/>
            </v-col>
        </v-row>
      </v-col>
      <v-col lg="3" sm="5" cols="12">
        <v-text-field
          v-model="configDatatale.paramsRequest._search"
          append-icon="mdi-magnify"
          :label="$t('Key word')"
          outlined
          dense
          hide-details
          @keydown.enter="handleSearch($event)"
        />
      </v-col>
      <v-col lg="1" sm="2" cols="12">
        <v-btn
          color="primary"
          medium
          outlined
          @click="handleSearch($event)"
        >
          {{ $t('Search') }}
        </v-btn>
      </v-col>
    </v-row>
    <datatable ref="tasksDatatable" :config="configDatatale" />

    <dialog-project-manager-review
      ref="projectManagerReview"
      @submit="submittedReviewed"
    />
  </div>
</template>

<script>
import Datatable from '@/components/Datatable'
import { get, call } from 'vuex-pathify'
import { utcToLocal } from '@utils'
import DialogProjectManagerReview from './components/DialogProjectManagerReview'
import Datepicker from '@/components/Datepicker'

export default {
  name: 'TaskEvaluationIndex',
  components: {
    Datatable,
    DialogProjectManagerReview,
    Datepicker
  },
  data: vm => ({
    configDatatale: {
      url: '/api/tasks/manager-datatable',
      queryBuilder: {
        _include: ['user:id,name', 'project.manager', 'managerReview']
      },
      operations: [
        {
          color: 'primary',
          text: 'Review',
          icon: 'mdi-eye',
          method: function (item) {
            vm.$refs.projectManagerReview.setData({
              id: item.id,
              status: item.status,
              manager_review: item.manager_review || null
            })
            return false
          }
        }
      ],
      columns: [
        {
          text: 'ID',
          data: 'id',
          name: 'id'
        },
        {
          text: vm.$t('Task'),
          data: 'name',
          name: 'name',
          component: true,
          render: function(item, column) {
            if (!item) {
              return null
            }
            return `<router-link :to="{ name: 'my-workings.detail', params: {id:${item.id}} }">${item.name}</router-link>`
          }
        },
        {
          text: vm.$t('Project'),
          data: 'project.name',
          name: 'project.name',
          component: true,
          render: function(item, column) {
            if (!item) {
              return null
            }
            return `<router-link :to="{ name: 'projects.show', params: {id:${item.project.id}} }">${item.project.name}</router-link>`
          }
        },
        {
          text: vm.$t('Employee'),
          data: 'user.name',
          name: 'user.name',
          searchable: true,
          orderable: false
        },
        {
          text: vm.$t('Status'),
          data: 'status',
          name: 'status',
          render: function(item, column) {
            if (!item) {
              return null
            }
            return vm.__attr(item[column])
          }
        },
        {
          text: vm.$t('Created at'),
          data: 'created_at',
          name: 'created_at',
          render: function(item, column) {
            if (!item) {
              return null
            }
            return utcToLocal(item[column], 'DD/MM/YYYY HH:mm')
          }
        },
        {
          text: vm.$t('Average'),
          data: 'manager_review.avg',
          name: 'manager_review.avg',
          searchable: false,
          orderable: false
        },
        {
          text: vm.$t('Operations'),
          data: '_operations',
          name: null,
          searchable: false,
          orderable: false,
          search: {
            value: null,
            regex: false
          }
        }
      ],
      setting: {
        displaySearchInput: false,
        operationStyle: 'ProjectManagerReviewTask',
        actions: {
          review: (item) => {
            vm.$refs.projectManagerReview.setData(item)
            return false
          }
        }
      },
      paramsRequest: {
        status: '',
        from_date: null,
        to_date: null,
        user_id: null,
        _search: null
      }
    }
  }),
  computed: {
    ...get('common', ['task_status']),
    selectUsers: get('user/selectUsers'),
    statusFillter() {
      return [
        {
          text: 'All',
          value: ''
        },
        ...this.task_status
      ]
    }
  },
  mounted() {
    this.fetchAllUsers()
  },
  methods: {
    fetchAllUsers: call('user/all'),

    handleSearch(e) {
      e.preventDefault()
      const filter = {
        ...this.configDatatale.paramsRequest
      }
      this.$refs.tasksDatatable.setParamsRequest(filter)
      this.$refs.tasksDatatable.fetchData()
      return false
    },

    submittedReviewed(task) {
      this.$refs.tasksDatatable.setDataById(task.id, task)
    }
  }
}
</script>
